import React from "react";
import { connect } from "react-redux";
import { useQuery } from "@tanstack/react-query";

const ReferAFriend = ({ currentUser }) => {
  const companyQuery = useQuery({
    queryKey: [`company/${currentUser?.currentCompanyId}`],
    enabled: currentUser?.currentCompanyId != null,
  });
  if (
    currentUser.currentCompanyId == null ||
    companyQuery.isLoading ||
    companyQuery.data?.referralPromotionCode == null
  ) {
    return null;
  }
  return (
    <div className="text-snow-white mx-2 my-4 justify-center flex border border-snow-white rounded-md p-2 flex-col">
      <h3 className="text-sm">Refer a Friend</h3>
      <p className="text-xs">
        Use the code {companyQuery.data.referralPromotionCode}. They get 50% off
        for 6 months and you get $100 credit or 1 month free (which ever is
        greater).{" "}
        <a className="underline" href="/refer-a-friend">
          Terms apply
        </a>
        .
      </p>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { currentUser, metadata } = state;
  return { currentUser, metadata };
};

export default connect(mapStateToProps)(ReferAFriend);
